import React, { Component } from 'react';
import { Heading, Section } from 'components';
import './HomeIntro.scss';

class HomeIntro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opacity: 1,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = window.scrollY;
    const itemOpacity = Math.round((1 - scrollTop * 0.015) * 100) / 100;

    this.setState({
      opacity: itemOpacity,
    });
  };

  render() {
    const { opacity } = this.state;

    return (
      <div id={'home-intro'}>
        <Section
          color={'mine-shaft'}
          additionalClass={'home-intro'}
          containerClass={'home-intro__container'}
        >
          <div className={'home-intro__heading'}>
            <Heading
              type={1}
              additionalClass={'text--light text--white home-intro__subtitle'}
              style={{ opacity }}
            >
              <p style={{ opacity }}>
                The digital product design &amp; development
                <br />
                company and your guide on the digital
                <br />
                transformation journey.
              </p>
            </Heading>
          </div>
          <div className={'home-intro__contact'} style={{ opacity }}>
            <div className={'home-intro__description'}>
              Do you have a product in mind?
              <br />
              Get in touch.
            </div>
          </div>
        </Section>
      </div>
    );
  }
}

export default HomeIntro;
